import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const CONTENT_TEXT_ROWS = 5;

const AddressCard = ({ data }) => {
  const [contentTextHeight, setContentTextHeight] = useState(0);
  const [contentBoxHeight, setContentBoxHeight] = useState(0);
  const contentTextElementRef = useRef(null);

  useEffect(() => {
    const textElement = contentTextElementRef.current;
    if (textElement !== null) {
      const textHeight = textElement.offsetHeight;
      setContentTextHeight(textHeight);
    }
  }, []);

  useEffect(() => {
    setContentBoxHeight(contentTextHeight * CONTENT_TEXT_ROWS);
  }, [contentTextHeight]);

  return (
    <Grid container direction="column" className="address-card-container">
      <Grid item container direction="column" className="address-card-header">
        <Typography variant="body1" textAlign="center" fontWeight="inherit">
          inland postage paid
        </Typography>
        <Typography variant="body1" textAlign="center" fontWeight="inherit">
          m-10250/245
        </Typography>
      </Grid>
      <Divider className="address-card-divider" />
      <Grid
        item
        container
        direction="column"
        className="address-card-content"
        height={contentBoxHeight ?? "auto"}
        wrap="nowrap"
      >
        {contentTextHeight === 0 ? (
          <Typography ref={contentTextElementRef} className="content-text">
            SampleText
          </Typography>
        ) : (
          <>
            <Typography className="content-text">
              {data.customerName}
            </Typography>
            <Typography className="content-text">
              {data.addressLine1}
            </Typography>
            <Typography className="content-text">
              {data.addressLine2}
            </Typography>
            <Typography className="content-text">{data.addressCity}</Typography>
          </>
        )}
      </Grid>
      <Divider className="address-card-divider" />
      <Grid item container direction="column" className="address-card-footer">
        <Typography
          variant="caption"
          textTransform="capitalize"
          textAlign="start"
          fontWeight={500}
          style={{ textDecoration: "underline"}}
        >
          if undelivered, please return to:
        </Typography>
        <Typography
          variant="body2"
          textTransform="capitalize"
          textAlign="start"
          fontWeight={400}
        >
          Poruwa.lk, <br></br>P.O Box 5,<br></br>Nugegoda
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AddressCard;
